import React from 'react';
import propTypes from 'prop-types';
import ability from '../ability';

/**
 * checks user permission on children components and renders if allowed
 * @returns {React.Component} Canvas Can component
 */
const Can = ({
  atLeastOne,
  read,
  edit,
  component,
  folder,
  report,
  lanId,
  permissions,
  showAccessDenied,
  children
}) => {
  const isAllowed = ability.can({
    atLeastOne,
    read,
    edit,
    component,
    folder,
    report,
    permissions
  });

  if (isAllowed) {
    return children;
  }
  if (showAccessDenied && lanId) {
    return 'Access is denied!';
  }

  return null;
};

Can.propTypes = {
  atLeastOne: propTypes.bool,
  read: propTypes.bool,
  edit: propTypes.bool,
  folder: propTypes.oneOfType([propTypes.shape(), propTypes.bool]),
  component: propTypes.oneOfType([propTypes.shape(), propTypes.bool]),
  report: propTypes.oneOfType([propTypes.string, propTypes.bool]),
  permissions: propTypes.shape({
    folders: propTypes.shape({
      read: propTypes.arrayOf(propTypes.string),
      edit: propTypes.arrayOf(propTypes.string)
    }),
    components: propTypes.shape({
      read: propTypes.arrayOf(propTypes.string),
      edit: propTypes.arrayOf(propTypes.string)
    })
  }),
  showAccessDenied: propTypes.bool,
  children: propTypes.node
};

Can.defaultProps = {
  showAccessDenied: false
};

export default Can;
